import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { createMediaBookmark, deleteMediaBookmark } from "../api/public-voissa/medias";
import { USER_CURRENT_KEY } from "../api/public-voissa/users";
import useCurrentUserActionLocked, {ACTION_LOCKED} from "./useCurrentUserActionLocked";

const useMediaBookMark = ({
    isBookmarked = false,
    mediaId,
    onSuccess = () =>{},
    onMutate = () =>{},
    onError = () =>{}
})=>{
    const queryClient = useQueryClient();

    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const [_isBookmarked, setBookmarked] = useState(!!isBookmarked);


    useEffect(() => {
        setBookmarked(isBookmarked);
    }, [isBookmarked]);

    async function handleSuccess(){
        // await queryClient.invalidateQueries([MEDIA_KEY, mediaId]);
        // await queryClient.invalidateQueries([USER_BOOKMARKS_MEDIAS_KEY]);
        onSuccess();
    }

    function handleError (){
        setBookmarked(!_isBookmarked);
        onError();
    }

    const {
        mutate,isLoading,
    } = useMutation((bookmarked) =>  bookmarked ? deleteMediaBookmark(mediaId) : createMediaBookmark(mediaId),{
        onSuccess: handleSuccess,
        onError: handleError
    });

    const {handleLockedAction} = useCurrentUserActionLocked({action : ACTION_LOCKED.CREATE_BOOKMARK});

    function handleBookmark() {
        if(!isLoading){
            if(currentUser){
                setBookmarked(!_isBookmarked);
                mutate(_isBookmarked);
                onMutate(!_isBookmarked)
            }
            else{
                //navigate(createLink("signin"));
                handleLockedAction();
            }
        }
    }

    return {isBookmarked:_isBookmarked, handleBookmark}
}

export default useMediaBookMark;